// ============================================================
//  src/modal-autorizar-drive.js — Modal de autorización Drive
// ============================================================

import { mostrarToast, toggleBoton } from './ui.js';
import { mensajeErrorDrive }          from './drive-errors.js';
import { guardarPerfil }              from './perfil-datos.js';
import { t }                          from './i18n.js';
import { getAuth }                    from 'firebase/auth';
import { getProvider }                from './storage/storage.js';

let accionPendiente = null;

// ============================================================
//  API pública
// ============================================================

export function mostrarModalAutorizacion(callbackDespuesDeAutorizar) {
    accionPendiente = callbackDespuesDeAutorizar;
    const overlay = document.getElementById('modal-autorizar-drive');
    overlay?.classList.add('modal--visible');
}

export function cerrarModalAutorizacion() {
    const overlay = document.getElementById('modal-autorizar-drive');
    overlay?.classList.remove('modal--visible');
    accionPendiente = null;
}

export async function manejarAutorizarDrive() {

    toggleBoton('btn-autorizar-drive', false, t('drive.autorizando'));

    try {

        const ok = await getProvider('user_drive').requestAuthorization();

        if (ok === true) {

            cerrarModalAutorizacion();
            mostrarToast(t('toast.drive.conectado'), 'exito');

            const usuarioActual = getAuth().currentUser;

            if (usuarioActual) {
                guardarPerfil(usuarioActual.uid, { driveAutorizado: true })
                    .catch(e => console.warn('[ModalDrive] No se pudo guardar driveAutorizado:', e));
            }

            if (accionPendiente) {
                const accion = accionPendiente;
                accionPendiente = null;
                await accion();
            }

        } else if (ok && ok.pending) {

            cerrarModalAutorizacion();
            mostrarToast(t('toast.drive.codigo-recibido'), 'info', 7000);

            const usuarioActual = getAuth().currentUser;
            if (usuarioActual) {
                guardarPerfil(usuarioActual.uid, { driveAutorizado: true })
                    .catch(() => {});
            }

        } else {
            mostrarToast(
                t('toast.drive.error.autorizar2'),
                'error',
                6000
            );
        }

    } catch (error) {

        console.error('[ModalDrive] Error al autorizar:', error);
        mostrarToast(
            mensajeErrorDrive(error, t('toast.drive.error.autorizar2')),
            'error',
            7000
        );

    } finally {

        toggleBoton('btn-autorizar-drive', true);

    }
}
